import _ from 'lodash';
import { UNITS, TYPES } from '../../utils/webhookTypes';
import { nameValidator, callbackUriValidator } from '../../../../../../services/validators/common';

const typeValidator = type => !!type && TYPES[type];

const validators = {
  type: typeValidator,
  name: nameValidator,
  callbackUri: callbackUriValidator,
  frequency: (obj) => {
    if (_.isEmpty(obj)) {
      return false;
    }
    switch (obj.frequency) {
      case 'hourly':
        return !!obj.hourly;
      case 'daily':
        return !!obj.daily;
      case 'weekly':
        return !!obj.weekly;
      case 'monthly':
        return !!obj.monthly;
      default:
        return false;
    }
  },
  events: keys => !!keys && keys.length > 0,
  units: units =>
    !!units &&
      (units.toLowerCase() === UNITS.IMPERIAL ||
        units.toLowerCase() === UNITS.METRIC),
  permissions: keys => !!keys && keys.length > 0,
};

export default { validators };

